import { ColumnTitles } from "../typescript/interfaces/table";

export const TITLE = "Clinical Pipeline";

export const COLUMN_TITLES: ColumnTitles = {
  brandName: "Pipeline Drug Name",
  brandCompanies: "Brand Company",
  routesOfAdministration: "Route",
  mechanismsOfAction: "Mechanism of Action",
  indications: "Indication",
  stages: "Stage",
  submissionTypes: "Sub",
  view: "View",
};

export const EXPORT_HEADERS = [
  { label: COLUMN_TITLES.brandName, key: "brandName" },
  { label: "Generic Name", key: "genericName" },
  { label: COLUMN_TITLES.brandCompanies, key: "brandCompanies" },
  { label: COLUMN_TITLES.routesOfAdministration, key: "routesOfAdministration" },
  { label: COLUMN_TITLES.mechanismsOfAction, key: "mechanismsOfAction" },
  { label: COLUMN_TITLES.indications, key: "indications" },
  { label: COLUMN_TITLES.stages, key: "stages" },
  { label: COLUMN_TITLES.submissionTypes, key: "submissionTypes" },
  { label: "Tags", key: "tags" },
  { label: "Expected FDA Exclusivities", key: "exclusivities" },
];
